import { createSlice } from "@reduxjs/toolkit";
import {getIdpRepo,getEngineeringIdpNonPanCollegesRepo, postIdpRepo, postImsPushRepo, clavertapPushRepo} from '../../repositories/idp/idp'

const idpFormlSlice = createSlice({
  name: "idpFormreducer",
  initialState: {
    //Get IDP
    getIdpLoading: null,
    getIdpSuccess: null,
    getIdpError: null,

    getNonpanCollegesSuccess:null,

    //POST IDP
    postIdpSuccess: null,
    postIdpError: null,  
    //POST LMS
    postImsPushSuccess: null,
    postImsPushError: null,  

    //clavertapPushRepo
    postClavertapSuccess: null,
    postClavertapError: null,  
  },

  reducers: {
    
    //GET IDP status
    getIdpLoading(state, action) {
      return {
        ...state,
        getIdpLoading: true,
      };
    },
    getIdpSuccess(state, action) {
      return {
        ...state,
        getIdpLoading: false,
        getIdpSuccess: action.payload,
      };
    },
    getIdpFailure(state, action) {
      return {
        ...state,
        getIdpLoading: false,
        getIdpError: action.payload,
      };
    },
    //getNonpanCollegesSuccess
    collegeNonpan(state, action) {
      return {
        ...state,
        getNonpanCollegesSuccess: action.payload,
      };
    },
    //POST IDP
    postIdpSuccess(state, action) {
      return {
        ...state,
        postIdpSuccess: action.payload,
      };
    },
    postIdpFailure(state, action) {
      return {
        ...state,
        postIdpError: action.payload,
      };
    },

    // POST LMS 
    postImsPushSuccess(state, action) {
      return {
        ...state,
        postImsPushSuccess: action.payload,
      };
    },
    postImsPushFailure(state, action) {
      return {
        ...state,
        postImsPushError: action.payload,
      };
    },

    // POST CLAVERTAP
    postClavertapSuccess(state, action) {
      return {
        ...state,
        postClavertapSuccess: action.payload,
      };
    },
    postClavertapFailure(state, action) {
      return {
        ...state,
        postClavertapError: action.payload,
      };
    },
  },
});

export const {
  getIdpLoading,
  getIdpSuccess,
  getIdpFailure,

  collegeNonpan,
  
  postIdpSuccess,
  postIdpFailure,
  
  postImsPushSuccess,
  postImsPushFailure,

  postClavertapSuccess,
  postClavertapFailure
} = idpFormlSlice.actions;

//Get IDP Data 
export const getIdpData = (params) => {
  return async (dispatch) => {
    await getIdpRepo(params)
      .then((response) => {
        if (response.status === 200) {
          dispatch(getIdpSuccess(response?.data));
        } else {
          dispatch(getIdpFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getIdpFailure(error.message));
        }
      });
  };
};

export const getcollegeNonpanData = (params) => {
  return async (dispatch) => {
    await getEngineeringIdpNonPanCollegesRepo(params)
      .then((response) => {
        if (response.status === 200) {
          dispatch(collegeNonpan(response?.data));
        }
      })
  };
};


//POST IDP DATA
export const postIdpData = (data) => {
  return async (dispatch) => {
    await postIdpRepo(data)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch(postIdpSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postIdpFailure(error.message));
        }
      });
  };
};
// POST LMS DATA
export const postImsPush = (data) => {
  return async (dispatch) => {
    await postImsPushRepo(data)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch(postImsPushSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postImsPushFailure(error.message));
        }
      });
  };
};

// POST CLAVERTAP
export const postClavertap = (data) => {
  return async (dispatch) => {
    await clavertapPushRepo(data)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch(postClavertapSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postClavertapFailure(error.message));
        }
      });
  };
};

export default idpFormlSlice.reducer;
